<template>
  <div class="our-partners">
    <h3 class="footer__title text--center-xs">Együttműködő partnereink</h3>

    <div class="our-partners__logos">
      <div>
        <img src="../assets/partners/hetfa-logo.png" alt="HÉTFA Kutatóintézet és Elemző Központ" class="our-partners__logo">
        <span class="our-partners__hetfa">
          Kutatóintézet és<br>
          Elemző Központ
        </span>
      </div>

      <div>
        <img src="../assets/partners/iposz.jpg" alt="IPOSZ" class="our-partners__logo our-partners__iposz">
        <p style="margin-top: 20px;">
          Ajka-Devecser és Térsége Ipartestület<br>
          GINOP-5.3.5-18-2019-00141 <router-link to="/ajka-devecser-es-tersege-ipartestulet" class="our-partners__info"><img src="../assets/icons/info.svg" class="icon" alt=""></router-link>
        </p>
        <p>
          Békéscsabai Ipartestület<br>
          GINOP-5.3.5-18-2019-00129 <router-link to="/bekescsabai-ipartestulet" class="our-partners__info"><img src="../assets/icons/info.svg" class="icon" alt=""></router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OurPartners'
}
</script>

<style lang="scss" scoped>
@import "../styles/tools/variables";
@import "../styles/tools/mixins";

.our-partners__logos {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  font-weight: bold;
  text-align: center;

  @include bp(tablet-portrait-and-up) {
    flex-direction: row;
  }
}

.our-partners__logo {
  display: block;
  margin: 0 auto 5px;
}

.our-partners__hetfa {
  display: block;
  line-height: 1.9;
}

.our-partners__iposz {
  height: 80px;
  margin-top: 10px;
}

.our-partners__info {
  position: relative;
  top: 1px;
}
</style>



// WEBPACK FOOTER //
// OurPartners.vue?96e609a0